<div class="bf">
  <header class="bf-cabecalho">
    <button type="button" class="bf-voltar" (click)="cancelar()"><i class="fe-arrow-left"></i> Banners</button>
    <h4 class="page-title bf-titulo"><i class="fas fa-images"></i> {{ banner.id ? 'Editar banner' : 'Novo banner' }}</h4>
  </header>

  <div class="bf-grade">
    <div class="bf-coluna">
      <!-- Imagem: fora do form, porque os botões do corte não têm type e enviariam o formulário -->
      <section class="bf-card" (mouseenter)="imagemUpload.marqueComoAtiva()">
        <div class="bf-card-topo">
          <div>
            <h5>Imagem</h5>
            <p>Formato largo 4:1, mínimo 992 × 240 px. Texto importante no centro, longe das bordas.</p>
          </div>
          <button type="button" class="bf-botao" *ngIf="banner.linkImagem && !imagemUpload.exibirSelecionarImagem()"
                  (click)="imagemUpload.editarImagem = true">
            <i class="fe-refresh-cw"></i> Trocar imagem
          </button>
          <button type="button" class="bf-link" *ngIf="banner.linkImagem && imagemUpload.editarImagem" (click)="fecheEditor(imagemUpload)">
            Cancelar
          </button>
        </div>

        <div class="bf-imagem-atual" *ngIf="banner.linkImagem && !imagemUpload.exibirSelecionarImagem()">
          <img [src]="'/images/empresa/' + banner.linkImagem" alt="Imagem do banner">
          <small class="bf-dica-colar">Para trocar, cole outra imagem com <kbd>{{ teclaColar }}</kbd><kbd>V</kbd></small>
        </div>

        <div class="bf-upload">
          <app-upload-crop-imagem #imagemUpload ratio="4" [resizeWidth]="1240" [minWidth]="992" [minHeight]="240"
                                  [semCabecalho]="true" [colarParaTrocar]="true" [confirmarSalvar]="false"
                                  [objeto]="banner" [prop]="'linkImagem'" [label]="'Imagem'"
                                  (onEnviou)="salveFotoBanner($event)"></app-upload-crop-imagem>
        </div>
      </section>

      <!-- Arte de celular: a peça 4:1 vira uma tarja de ~94px num aparelho de 375px.
           Opcional; sem ela a loja continua usando a peça larga. -->
      <section class="bf-card" (mouseenter)="imagemMobileUpload.marqueComoAtiva()">
        <div class="bf-card-topo">
          <div>
            <h5>Versão para celular <span class="bf-opcional">opcional</span></h5>
            <p>No celular a imagem larga vira uma faixa fina. Uma versão 3:2 (mínimo 600 × 400 px) aparece maior e mais legível.</p>
          </div>
          <div class="bf-card-acoes" *ngIf="banner.linkImagemMobile && !imagemMobileUpload.exibirSelecionarImagem()">
            <button type="button" class="bf-link" (click)="banner.linkImagemMobile = null">Remover</button>
            <button type="button" class="bf-botao" (click)="imagemMobileUpload.editarImagem = true">
              <i class="fe-refresh-cw"></i> Trocar
            </button>
          </div>
          <button type="button" class="bf-link" *ngIf="banner.linkImagemMobile && imagemMobileUpload.editarImagem" (click)="fecheEditor(imagemMobileUpload)">
            Cancelar
          </button>
        </div>

        <div class="bf-imagem-atual bf-imagem-atual--celular" *ngIf="banner.linkImagemMobile && !imagemMobileUpload.exibirSelecionarImagem()">
          <img [src]="'/images/empresa/' + banner.linkImagemMobile" alt="Imagem do banner para celular">
        </div>

        <div class="bf-upload bf-upload--celular">
          <app-upload-crop-imagem #imagemMobileUpload ratio="1.5" [resizeWidth]="750" [minWidth]="600" [minHeight]="400"
                                  [semCabecalho]="true" [colarParaTrocar]="true" [confirmarSalvar]="false"
                                  [objeto]="banner" [prop]="'linkImagemMobile'" [label]="'Foto para celular'"
                                  (onEnviou)="salveFotoBanner($event)"></app-upload-crop-imagem>
        </div>
      </section>

      <form class="bf-form" novalidate #frm="ngForm" (ngSubmit)="onSalvar()">
        <!-- Detalhes -->
        <section class="bf-card">
          <div class="bf-card-topo">
            <div>
              <h5>Detalhes</h5>
              <p>O nome é só para você encontrar o banner; o cliente vê apenas a imagem.</p>
            </div>
          </div>

          <div class="bf-campo">
            <label class="bf-rotulo" for="nome">Nome</label>
            <div class="bf-controle">
              <input type="text" class="bf-input" autocomplete="off" id="nome" name="nome"
                     [(ngModel)]="banner.nome" #nome="ngModel" placeholder="Ex.: Combo da semana" required
                     appAutoFocus [autoFocus]="!banner.id">
            </div>
            <span class="bf-erro" *ngIf="frm.submitted && nome.errors?.required">Dê um nome ao banner.</span>
          </div>

          <div class="bf-campo">
            <span class="bf-rotulo">Quando o cliente tocar no banner</span>
            <div class="bf-opcoes" role="radiogroup">
              <label class="bf-opcao" *ngFor="let opcao of opcoesComando" [class.is-marcada]="banner.comando === opcao.valor">
                <input type="radio" name="comando" [value]="opcao.valor" [(ngModel)]="banner.comando" required>
                <span class="bf-opcao-icone"><i [class]="opcao.icone"></i></span>
                <span class="bf-opcao-texto">
                  <strong>{{ opcao.titulo }}</strong>
                  <small>{{ opcao.descricao }}</small>
                </span>
                <span class="bf-opcao-marca"></span>
              </label>
            </div>
            <span class="bf-erro" *ngIf="frm.submitted && !banner.comando">Escolha o que acontece no toque.</span>
          </div>

          <div class="bf-campo bf-campo--extra" *ngIf="banner.comando === 'LINK'">
            <label class="bf-rotulo" for="extra_link">Endereço do site</label>
            <div class="bf-controle bf-controle--acao">
              <i class="fe-link"></i>
              <input type="text" class="bf-input" autocomplete="off" id="extra_link" name="extra_link"
                     [(ngModel)]="banner.extra" #extraLink="ngModel" placeholder="https://www.site.com.br" required>
              <button type="button" class="bf-botao bf-botao--pequeno" (click)="testarEndereco()" [disabled]="!banner.extra">Testar</button>
            </div>
            <span class="bf-erro" *ngIf="frm.submitted && extraLink.errors?.required">Informe o endereço do site.</span>
          </div>

          <div class="bf-campo bf-campo--extra" *ngIf="banner.comando === 'BUSCA'">
            <label class="bf-rotulo" for="extra_busca">Mostrar os produtos da busca</label>
            <div class="bf-controle bf-controle--acao">
              <i class="fe-search"></i>
              <input type="text" class="bf-input" autocomplete="off" id="extra_busca" name="extra_busca"
                     [(ngModel)]="banner.extra" placeholder="Ex.: combo, pizza doce, promoção">
              <button type="button" class="bf-botao bf-botao--pequeno" (click)="testarBusca()" [disabled]="!banner.extra">Testar</button>
            </div>
            <span class="bf-ajuda">O cliente cai no cardápio já filtrado por esse termo.</span>
          </div>

          <div class="bf-campo">
            <label class="bf-rotulo" for="validade">Validade <span class="bf-opcional">opcional</span></label>
            <div class="bf-data">
              <kendo-datepicker [(ngModel)]="banner.validade" id="validade" name="validade" [format]="'dd/MM/yyyy'"
                                placeholder="Sem data de fim">
                <kendo-datepicker-messages today="Hoje" toggle="Alterar data"></kendo-datepicker-messages>
              </kendo-datepicker>
              <button type="button" class="bf-link" *ngIf="banner.validade" (click)="banner.validade = null">Remover data</button>
            </div>
            <span class="bf-ajuda">Depois desse dia o banner sai do cardápio sozinho.</span>
          </div>
        </section>

        <div class="bf-alerta" role="alert" *ngIf="mensagemErro">
          <i class="fe-alert-triangle"></i> {{ mensagemErro }}
        </div>

        <footer class="bf-rodape">
          <button type="button" class="bf-botao" (click)="cancelar()">Cancelar</button>
          <button type="submit" class="bf-botao-primario" [disabled]="enviando">
            <i class="fe-check"></i> {{ enviando ? 'Salvando...' : 'Salvar banner' }}
          </button>
        </footer>
      </form>
    </div>

    <!-- Prévia -->
    <aside class="bf-previa" aria-label="Prévia do banner na loja">
      <span class="bf-previa-rotulo">Prévia no celular</span>
      <div class="bf-celular">
        <div class="bf-celular-tela">
          <div class="bf-celular-topo">
            <span class="bf-esq bf-esq-logo"></span>
            <span class="bf-esq bf-esq-titulo"></span>
          </div>
          <div class="bf-celular-banner" [class.is-vazio]="!banner.linkImagem" [class.is-celular]="banner.linkImagemMobile">
            <img *ngIf="banner.linkImagem" [src]="'/images/empresa/' + (banner.linkImagemMobile || banner.linkImagem)" alt="">
            <span *ngIf="!banner.linkImagem"><i class="fe-image"></i> Seu banner aparece aqui</span>
          </div>
          <div class="bf-celular-pontos"><i class="is-atual"></i><i></i><i></i></div>
          <div class="bf-esq-chips"><i></i><i></i><i></i></div>
          <div class="bf-esq-produto" *ngFor="let p of [1, 2, 3, 4]">
            <div><i class="bf-esq bf-esq-linha"></i><i class="bf-esq bf-esq-linha curta"></i></div>
            <span class="bf-esq bf-esq-foto"></span>
          </div>
        </div>
      </div>
    </aside>
  </div>
</div>
